jQuery(document).ready(function($) { 


  var header = $('#masthead');
  var h_window = $(window).height();

   /*  ***************************
    SCROLL FIXED MENU 
  ******************************** */
   $(window).scroll(function () {
     // if(l_window > 1023){
        action_on_scroll();
     // }
    });

    function action_on_scroll(){
      l_window = parseInt($(window).width());
       if ($(window).scrollTop() > 50){
          header.addClass("Masthead--sticky");
          $("body").addClass('header--sticky');
        }else{
           header.removeClass("Masthead--sticky");
           $("body").removeClass('header--sticky');
        }
   }



   /* ******************************************************** */
/* ******** LIGHTBOX - IFRAME HOME PAGE YOUTUBE   ********** */
/* ******************************************************** */
     
      if($(".open-popup-link"). length){
    
        $('document').ready(function(){
          $('.open-popup-link').magnificPopup({
            type:'inline',
            midClick: true,
            mainClass: 'mfp-fade',
            callbacks: {
            open: function() {
               videojs('showreel_lightbox').play();
            
                var mainVideo = $('#video_home');
                mainVideo[0].pause();

            },
            close: function() {
              videojs('showreel_lightbox').pause();
               var mainVideo = $('#video_home');
              mainVideo[0].play();
            }
            // e.t.c.
          }

          });
       
        });
      }


     /********************************/
  /* ********* SLIDER INVITE PAGE ACCUEIL *******/

   var swiper_Guest_home = new Swiper('.swiper-GuestNow-home', {

     // If we need pagination
       spaceBetween: 20,
       slidesPerView: 1.3,
       loop: true,
       allowTouchMove: true,
        autoplay: {
           delay: 5500,
           disableOnInteraction: true,
       },
       breakpoints: {
            1600: { // a partir de 769
              spaceBetween: 100,
              slidesPerView: 3.6,
            },

            1400: { // a partir de 769
              spaceBetween: 50,
              slidesPerView: 3.1,
            },

             1024: { // a partir de 10224
              spaceBetween: 80,
              slidesPerView: 2.6,
            },
            768: { // a partir de 10224
              spaceBetween: 60,
              slidesPerView: 2.6,
            },
            550: { // a partir de 10224
              spaceBetween: 60,
              slidesPerView: 1.8,
            },
            425: { // a partir de 10224
              spaceBetween: 40,
              slidesPerView: 1.6,
            }
      
      },
       navigation: {
            nextEl: '.only-guest-next',
            prevEl: '.only-guest-prev'
      },
    
      pagination: {
        el: '.GuestNow-pagination-render',
        type:"fraction",
         renderFraction: function (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' + '/' + '<span class="' + totalClass + '"></span>';
      },

       
    }

   });  



   /*************************************************************************************************/
   /************************** CLICK SUR FILTRE FILM / EVT DANS CALENDRIER **********************************/
   /*************************************************************************************************/

     // filter items on button click
    $('.NavSecondaire--Calendarjs').on( 'click', 'a', function() {
      var filterValue = $(this).attr('data-filter');
      if(filterValue == "*"){
        $('.ItemIsotopeJs').slideDown(300, function(){
           var parent = $(this).parent().parent();
          setTimeout(function(){   parent.slideDown(300); }, 10);
        });
      }
      else{
        $( ".ItemIsotopeJs" ).each(function( index ) {
          // if ((this).style.css('display') == 'none')

          if ($(this).hasClass(filterValue)){
              $(this).slideDown(300, function(){

                 if ($(this).parent().parent().css('display') == 'none'){
                  var parent = $(this).parent().parent();
                    setTimeout(function(){   parent.slideDown(300); }, 10);
                 }

              });
          }else{
            $(this).slideUp(300, function(){
              if (!$(this).parent().parent().hasClass(filterValue)){
                 var parent = $(this).parent().parent();
                setTimeout(function(){  parent.slideUp(300); }, 10);
             
              }
            });
          }


      });

      }
      
      // $grid.isotope({ filter: filterValue });
       $('.NavSecondaire--Calendarjs a').removeClass('active');
       $(this).addClass('active');

      return false;
    });




    /*******************/
     /* FILTER */
    /*******************/

    var coll = document.getElementsByClassName("collapsible");
    var i;

    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function() {
        this.classList.toggle("active");
        this.parentNode.classList.toggle("active_filters");
        // if(this.parentNode.classList.contains('active_filters')){

        // }
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }



    /*******************/
     /* GRID EVT - A COTE */
    /*******************/


    var $grid;

  // flatten object by concatting values
  function concatValues( obj ) {
    var value = '';
    for ( var prop in obj ) {
      value += obj[ prop ];
    }
    return value;
}


   if (document.querySelectorAll('#list-evt').length > 0)
    {
        var grid_isotope;
        var string_number_filter = document.getElementById('number-filter');
         $grid = $('.grid-event').imagesLoaded( function() {
            grid_isotope = $grid.isotope({
            itemSelector: '.event-item',
            percentPosition: true,
            layoutMode: 'masonry',
             masonry: {
                 columnWidth: '.grid-event-sizer',
                 gutter: '.gutter-event-sizer',
             }

          });

           init_scroll_highlight();
          //grid_isotope.on( 'layoutComplete', init_scroll_highlight );

        });





        
      // une fois que les images sont finies de chargées
    // $(window).on('load', function(){
    //   //$grid.isotope('reloadItems').isotope({sortBy: 'original-order'}); 
    //  });

     // ISOTOPE GRID //

        var filters = {};
        var $buttonGroup, filterGroup, filterValue;

        $( ".NavSecondaire--typeevt button").click(function() {

            $buttonGroup = $(this).parents('.NavSecondaire--typeevt');
            filterGroup = $buttonGroup.attr('data-filter-group');
              // set filter for group
            filters[ filterGroup ] = $(this).attr('data-filter');
            // combine filters
            filterValue = concatValues( filters );
            //console.log(filterValue);

            $(this).parents('.NavSecondaire--typeevt').find('button').removeClass('active');
             $(this).addClass('active');

             $grid.isotope({ filter: filterValue});

            string_number_filter.textContent = "("+grid_isotope.data('isotope').filteredItems.length+")";
            var elm = string_number_filter;
            var newone = elm.cloneNode(true);
            string_number_filter = newone;
            elm.parentNode.replaceChild(newone, elm);
            return false;

        });


      }


    /**********************************************************************/
      /*************** Galerie d'image // Flexible  ****************/
    /**********************************************************************/

     

     $( ".mF_Gallery .gallerie-thumb" ).each(function( index ) {
        var id_galerie_masonry = $(this).attr('id');
          lightGallery(document.getElementById(id_galerie_masonry), {
             plugins: [lgThumbnail],
             selector: '.item-img',
             subHtmlSelectorRelative: true,
             thumbnail: true,
             mobileSettings: {
              controls: true,
              showCloseIcon: true,
              download: false
            }
         });
     });


       /**********************************************************************/
      /*************** SCROLL ANCHOR  ****************/
    /**********************************************************************/

         var top_scroll = 140;
       $(document).on("click", ".link_to_scroll", function(e) {
         var item_split = $(this).attr("href");
         var offsetTop = $(item_split).offset().top-top_scroll;

          $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 600);
          e.preventDefault();
      });



    ////////////////
    //// GLOBAL accordion 
   ///////////////
   $('.accordion-section-content:not(.first)').hide();
   $('.acc-item.first').addClass('active');
    //$('#content_s_1').parent().find('h2 a').addClass('active');

   //$('.accordion-section-content').hide();
    // accordion SECTION 
    function close_accordion_section() {
        $('.accordion-page .accordion-section-title').removeClass('active');
        $('.accordion-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('aria-controls');
      
        var parentActiveAcc = $(this).parent().parent().parent().attr('data-accordion-id');

         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).slideUp(300);
         $(parentActiveAcc + ' .acc-item.active .accordion-section-title:not([aria-controls="'+currentAttrValue+'"])').attr('aria-expanded', 'false');
         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $(this).attr('aria-expanded', 'false');
            $('.accordion-page ' + '#'+currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            $(this).attr('aria-expanded', 'true');
            // Open up the hidden content panel
            $('.accordion-page ' + '#'+currentAttrValue).slideDown(300).addClass('open');
            if($('#'+currentAttrValue+'-number').length){
              let to_number = $('#'+currentAttrValue+'-number').attr('data-number');
              let demo = new countUp.CountUp(currentAttrValue+'-number', to_number, options_count);
              demo.start();
            } 
            
        }
 
        e.preventDefault();
    });
    // FIN accordion //
    ////////////////////


    /////// SCROLL FLUIDE ///////
    function init_scroll_highlight(){
      console.log('HERE');
       // Récupère la partie de l'ancre dans l'URL (ex: #section1)
    var anchor = window.location.hash;

    if (anchor) {
        // Supprime le # pour ne garder que l'identifiant
        var id = anchor.substring(1);
        var $element = $('#' + id);

        // Vérifie si l'élément existe
        if ($element.length) {
            // Ajoute la classe highlight
            $element.addClass('highlight');

            // Scroll fluide vers l'élément
            $('html, body').animate({
                scrollTop: $element.offset().top - top_scroll
            }, 600); // 600ms = durée du scroll
        }
    }

   }

}); // fin ready menu